/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  let random = Math.floor(Math.random() * 9) + 1
  
  let bgclass = `d-flex flex-column flex-column-fluid flex-lg-row  bg-body-image bg-body-image${random}`;
  bgclass = `d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed  bg-body-image-data bg-body-image-top bg-body-image${random}`;
  bgclass = `d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed  bg-body-image-data bg-body-image-top bg-body-image-header`;
  return (
    <>


      <div className={bgclass} >

        <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">

         
            <a href="#" className="mb-12">
              <img alt="Logo" src="/media/logos/INSIGHT-negativo.png" style={{width: "200px"}} />
            </a>

          

          
        
        <div className="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">

     

              <Outlet />


        </div>
        </div>
      </div>
    </>
  );

}

export { AuthLayout }
